import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { FC, PropsWithChildren } from "react";

import { useRtl } from "@ryde/redux";

import { MuiButton } from "./button";

interface IBulkOperationsButtonProps {
  onClick?: () => void;
  href?: string;
  isDisabled?: boolean;
}

export const BulkOperationsButton: FC<
  PropsWithChildren<IBulkOperationsButtonProps>
> = ({ onClick, href, children, isDisabled }) => {
  const { isRtl } = useRtl();

  return (
    <MuiButton
      muiVariant="text"
      muiSize="large"
      muiStyle="info"
      onClick={onClick}
      href={href}
      e2eData="bulk-operations-button"
      disabled={isDisabled}
    >
      {children}
      {!isRtl && <ArrowForward color="primary" />}
      {isRtl && <ArrowBack color="primary" />}
    </MuiButton>
  );
};
